<template>
  <div class="login-wrapper">
    <el-form ref="form" :model="form" :rules="rules" label-width="80px" class="login-box">
      <h3 class="login-title">欢迎登录</h3>
      <el-form-item label="手机号" prop="phone"
        :rules="[
          { required: true, message: '手机号不能为空', trigger: 'blur'},
        ]"
      >
        <el-input type="text" placeholder="请输入手机号" v-model="form.phone"/>
      </el-form-item>

      <el-form-item label="密码" prop="password"
        :rules="[
          { required: true, message: '密码不能为空', trigger: 'blur'}
        ]"
      >
        <el-input type="password" placeholder="请输入密码" v-model="form.password" show-password autocomplete="off"/>
      </el-form-item>
      
      <el-form-item class="login-button">
        <el-button type="primary" v-on:click="onSubmit">登录</el-button>
        <router-link class="register-link" :to="{path:'/register'}">注册</router-link>
      </el-form-item>
    
    </el-form>

  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'Login',
  data: function () {
    return {
      form: {
        phone: '',
        password: ''
      },
      // 表单验证，需要在 el-form-item 元素中增加 prop 属性
      rules: {
        phone: [
          {required: true, message: '手机号不可为空', trigger: 'blur'}
        ],
        password: [
          {required: true, message: '密码不可为空', trigger: 'blur'}
        ]
      },
      // 对话框显示和隐藏
      dialogVisible: false
    }
  },
  methods: {
    onSubmit() {
      const that = this
      // 为表单绑定验证功能
      that.$refs['form'].validate((valid) => {
        if (valid) {
          that.login()
        }
      });
    },
    login() {
      const that = this
      const params = new FormData()
      params.append('phone', that.form.phone)
      params.append('password', that.form.password)

      console.log(params)
      that.axios
        .post('/user/login',
          params)
        .then(data => {
          console.log(data)
          if (data.code != 0) {
            that.$message("手机号或密码不正确!")
            return
          }
          // 将username存入vuex
          that.$store.commit('setUserInfo', data.data)
          //跳转到首页
          that.$router.push({ path: '/' })
        })
    }
  }
}
</script>

<style lang="stylus" scoped>
.login-wrapper
  .login-box
    border: 1px solid #DCDFE6
    width: 350px
    margin: 180px auto
    padding: 35px 35px 15px 35px
    border-radius: 5px
    -webkit-border-radius: 5px
    -moz-border-radius: 5px
    box-shadow: 0 0 25px #909399
  .login-title
    text-align: center
    margin: 0 auto 40px auto
    color: #303133
  .login-button
    >>> .el-button
      width: 150px
  .register-link
    padding-left: 60px
</style>